var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white mt-5 p-4 rounded"},[_c('most-popular',{staticClass:"mb-4"}),_c('side-search',{staticClass:"mb-4"}),_c('side-categoreis'),_c('hr',{staticClass:"my-4 -mx-6"}),_c('latest-posts'),_c('sidebar-ad')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }